import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const PersonalizedReco: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'featureslandingpage_title_musicandpodactstoyourtaste_standalone-web',
							{ns: 'features'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_musicandpodactstoyourtaste_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					src="30557a852a57c99e0da5feedbbb7a1a9.png"
					aspectRatio="2880/840"
					alt={t('metatag_text_personalizedmusicreco_standalone-web', {
						ns: 'common',
					})}
					priority
					quality={90}
				/>
			}
		/>
	);
};
